
import ProductCard from '~/components/product/ProductCard.vue';
import SPage from '~/components/page/SPage.vue';
import { DownloadHelper } from '~/helpers/DownloadHelper';

export default {
  name: 'DocumentGost',
  data() {
    return {
      products: [],

      currentInfoGost: {},
      pagination: {
        page: 1,
        totalPage: 1,
      },

      isLoading: false,
    };
  },
  head() {
    const head = {
      title: this.currentInfoGost?.seo_title || this?.currentInfoGost?.name || '',
      meta: [],
    };

    const description = this.currentInfoGost?.seo_description || '';
    head.meta.push({ hid: 'metadescription', name: 'description', content: description });

    return { ...head };
  },
  async fetch() {
    await this.getGost();
  },
  components: {
    SPage,
    ProductCard,
    Pagination: () => import('~/components/UI/Pagination.vue'),
  },
  computed: {
    gostDescription() {
      return this.currentInfoGost?.description || '';
    },
    sortedCategoriesProducts() {
      const products = [...this.products];
      const newObj = {};

      products.forEach((product) => {
        const { category } = product;
        if (newObj[category.name]) {
          newObj[category.name].items.push(product);
        } else {
          newObj[category.name] = {
            category: category.name,
            items: [product],
          };
        }
      });

      return Object.values(newObj);
    },

    breadcrumbsList() {
      return [
        { title: 'Главная', path: '/' },
        { title: 'Нормативная документация', path: '/normdocument' },
        { title: this?.currentInfoGost?.name || '', path: this?.currentInfoGost?.slug || '' },
      ];
    },
  },
  methods: {
    async downloadFile() {
      if (!this?.currentInfoGost?.file_id) {
        return;
      }
      const fileId = this?.currentInfoGost?.file_id;

      const authToken = this.$cookies.get('authToken');
      const sessionToken = this.$cookies.get('sessionToken');

      await DownloadHelper({
        fileId, baseUrl: process.env.baseApiUrl, authToken, sessionToken,
      });
    },
    async getGost(params = {}) {
      const slug = this.$route?.params?.slug || '';
      const page = params?.newPage || this.$route.query?.page || this.pagination.page;

      if (!slug) {
        this.$nuxt.error({
          statusCode: 404,
        });

        return;
      }
      this.isLoading = true;
      const response = await this.$api.agent.transport
        .get(`gost/view-by-slug?slug=${slug}&page=${page}`)
        .then((res) => res)
        .catch(() => null);

      if (!response) {
        this.$nuxt.error({
          statusCode: 404,
        });
        this.isLoading = false;
        return;
      }

      const pagination = {
        page: Number.parseFloat(response?.headers?.['x-pagination-current-page'] || 1),
        totalPage: Number.parseFloat(response?.headers?.['x-pagination-page-count'] || 1),
      };
      const products = response?.data.products || [];
      this.currentInfoGost = response?.data?.model || {};
      this.setSearchParams(pagination.page);

      this.products = products;
      this.pagination = pagination;
      this.isLoading = false;
    },
    async changePage(newPage) {
      const pagination = { ...this.pagination };
      pagination.page = newPage;
      this.pagination = pagination;

      window.scrollTo({
        top: 0,
      });

      await this.getGost({ newPage });
    },
    setSearchParams(page) {
      if (!process.client) {
        return;
      }

      const search = [
        `page=${page}`,
      ];

      if (page === 1) {
        window.history.replaceState(null, null, `${window.location?.pathname}`);
      } else {
        window.history.replaceState(null, null, `${window.location?.pathname}?${search.join('&')}`);
      }
    },
  },
};
